import { useEffect } from "react";
import AOS from "aos";
import { Helmet } from "react-helmet-async";
import { useTranslation } from "react-i18next";
import ContactFloat from "@/components/ContactFloat";
import IndustrySolutionSections from "@/components/IndustrySolutionSections";
import KnowledgeBaseMindMap from "@/components/KnowledgeBaseMindMap";

export default function EmbodiedRobotSolutions() {
  const { t } = useTranslation();

  useEffect(() => {
    AOS.init({
      offset: 100,
      easing: "ease-out-back",
      duration: 1000,
      delay: 100,
    });
  }, []);

  return (
    <>
      <Helmet>
        <title>{t("embodiedRobot.title")}</title>
        <meta name="keywords" content={t("embodiedRobot.keywords")} />
        <meta name="description" content={t("embodiedRobot.description")} />
      </Helmet>
      <ContactFloat />

      <section
        className="w-full bg-[#1e1b4b]"
        data-aos="fade-right"
        data-aos-offset="100"
        data-aos-duration="500"
      >
        <div className="relative isolate h-[400px] w-full overflow-hidden">
          <img
            src="/solutions/robotEmbodied5.jpeg"
            alt=""
            className="absolute inset-0 h-full w-full object-cover object-[50%_25%]"
          />
          <div className="absolute inset-0 bg-linear-to-r from-[#0f0a2e]/92 via-[#0f0a2e]/72 to-transparent" />
          <div className="relative z-10 grid h-full w-1200 place-items-center px-4 text-center">
            <div>
              <h2
                className="text-[30px] leading-snug font-bold text-white"
                data-aos="fade-right"
                data-aos-offset="100"
                data-aos-duration="500"
              >
                {t("embodiedRobot.banner.title")}
              </h2>
              <span
                className="mx-auto mt-3 block h-[4px] w-[50px] bg-white"
                data-aos="zoom-in"
                data-aos-delay="300"
              />
              <p
                className="mt-5 text-base text-white/90 md:text-lg"
                data-aos="fade-left"
                data-aos-offset="100"
                data-aos-duration="500"
              >
                {t("embodiedRobot.banner.subtitle")}
              </p>
            </div>
          </div>
        </div>
      </section>

      <KnowledgeBaseMindMap
        rootLabel={t("embodiedRobot.knowledgeBase.rootLabel")}
        rootColor="#6366f1"
        treeTranslationKey="embodiedRobot.knowledgeBase.tree"
        i18nPrefix="embodiedRobot.knowledgeBase"
      />

      <IndustrySolutionSections
        i18nPrefix="embodiedRobot"
        images={{
          painPoints: "/solutions/robotEmbodied4.jpeg",
          solutions: "/solutions/robotEmbodied3.jpeg",
          cta: "/solutions/robotEmbodied1.jpeg",
        }}
        imagesPos={{
          cta: "50% 20%",
        }}
      />
    </>
  );
}
